import {getSelectedPaymentOptionIndex} from './getSelectedPaymentOptionIndex';
import {getPaymentOptionDisabledStatuses, getPaymentOptionHiddenStatuses} from './PaymentOptionDisabledSelectors';

export default (state) => {
  const optionDisabledStatuses = getPaymentOptionDisabledStatuses(state);
  const optionHiddenStatuses = getPaymentOptionHiddenStatuses(state);
  const selectedPaymentOptionIndex = getSelectedPaymentOptionIndex(state);
  
  if ((selectedPaymentOptionIndex || selectedPaymentOptionIndex === 0) && selectedPaymentOptionIndex > -1) {
    return !optionHiddenStatuses[selectedPaymentOptionIndex] && !optionDisabledStatuses[selectedPaymentOptionIndex];
  }
  
  return false;
};
